import { parseJSONScript } from "./utils/dom";

type WMUDomAPI = {
  parseJSONScript: typeof parseJSONScript;
};

const api: WMUDomAPI = {
  parseJSONScript,
};

window.WMUDom = api;

export { parseJSONScript };
export type { WMUDomAPI };
